// extracted by mini-css-extract-plugin
export default {"user":"icon_user__I-Wqr"};